<template>
<div class="verticalCenter">
    <div v-if="$store.state.forum.articleData && $store.state.forum.articleData.length > 0">
        <div v-for="item in $store.state.forum.articleData" :id="item.id" :key="item.id" class="forumBlock" @click="forumBlockClick">
            <div class="forumArticle">
                <div class="forumAuthor">
                  <base-button :style="{'background-color': `${item.category.color} !important`, 'border-color': `${item.category.color} !important`}" v-if="item.category" class="tag-style-left">
                    <span v-html="item.category[normalizeForumProp('name')]"></span>
                  </base-button>
                  <div>
                    {{$t('publishedBy')}}
                    <a class="underlined bold" @click.stop target="_blank" v-if="item.userPage" :href="item.userPage">{{item.authorName}}</a>
                    <span v-else v-html="item.authorName"></span>
                    <span v-if="item.userSpeciality">
                      (<a class="underlined bold" @click.stop target="_blank" v-if="item.userPage" :href="item.userPage">{{$t('consultationIn')}} <span v-html="item.userSpeciality[normalizeForumProp('name')]"></span></a>)
                    </span>
                    <!-- <span v-html="getTimeAgoFromDate(item.createdAt)"></span> -->
                    <base-button v-if="item.disease" class="tag-style-right">
                      <span v-html="item.disease[normalizeForumProp('name')]"></span>
                    </base-button>
                  </div>
                  <div style="font-size: 8px" v-if="item.lastInteractionDate">{{$t('lastInteraction')}} <span v-html="getTimeAgoFromDate(item.lastInteractionDate)"></span></div>
                </div>
                <base-button :style="{'background-color': `${item.category.color} !important`, 'border-color': `${item.category.color} !important`}" v-if="item.category" class="tag-style-mobile">
                  <span v-html="item.category[normalizeForumProp('name')]"></span>
                </base-button>
                <base-button v-if="item.disease" class="tag-style-mobile-disease">
                  <span v-html="item.disease[normalizeForumProp('name')]"></span>
                </base-button>
                <h3 v-if="item.title" class="forumArticleTitle" v-html="item.title"></h3>
                <img v-if="item.articlePicture && showImage" class="forumImageSize" :src="item.articlePicture" />
                <p v-if="!item.whoInData" class="forumDescription" :class="{'hide-forum-description-mobile': hideForumDescription}" v-html="item.description"></p>
                <p v-else :id="`whoInDescription-${item.id}`" class="forumDescription whoInDescription" :class="{'hide-forum-description-mobile': hideForumDescription}" v-html="item.description || (showFullWhoInDescription ? getWhoInDescription(item.whoInData) : getWhoInDescriptionShort(item.whoInData))"></p>
                <div v-if="!hideFooter">
                  <b-row v-if="!item.whoInData" class="forumFooter">
                    <b-col cols="3" v-if="!showAnswerBtn" class="py-2"><b-icon-chat-left class="margin-right-icon"></b-icon-chat-left><span class="hide-title-mobile">{{$t('commentaries')}}</span><span v-if="item.totalMessages"><span class="hide-title-mobile">: </span><span class="opensalud-blue">{{item.totalMessages}}</span></span></b-col>
                    <b-col cols="3" @click.stop="showEntryAnswerBlock" class="py-2" v-else><b-icon-chat-left class="margin-right-icon"></b-icon-chat-left><span class="hide-title-mobile">{{$t('answer')}}</span></b-col>
                    <b-col @click.stop="articleLike(item.id)" class="py-2" cols="3"><b-icon-hand-thumbs-up-fill class="opensalud-blue margin-right-icon" v-if="$store.state.forum.userBasicInfo.entriesLike.includes(item.id)"></b-icon-hand-thumbs-up-fill><b-icon-hand-thumbs-up class="margin-right-icon" v-else></b-icon-hand-thumbs-up><span class="hide-title-mobile">{{$t('like')}}</span><span v-if="item.likes"><span class="hide-title-mobile">: </span><span class="opensalud-blue">{{item.likes}}</span></span></b-col>
                    <b-col cols="3" class="py-2" @click.stop="saveArticle(item.id)"><b-icon-bookmark-check-fill class="opensalud-blue margin-right-icon" v-if="$store.state.forum.userBasicInfo.entriesSaved.includes(item.id)"></b-icon-bookmark-check-fill><b-icon-bookmark class="margin-right-icon" v-else></b-icon-bookmark><span class="hide-title-mobile">{{$store.state.forum.userBasicInfo.entriesSaved.includes(item.id) ? $t('saved') : $t('save')}}</span></b-col>
                    <b-col v-if="canEditForumEntry(item.id) || canModifyForumEntry(item.id)" class="py-2" :id="`more-options-${item.id}`" cols="3" @click.stop=""><b-icon-three-dots scale="1.5"></b-icon-three-dots></b-col>
                    <b-col v-else cols="3" class="py-2" @click.stop :id="`share-socials-${item.id}`"><b-icon-share class="margin-right-icon"></b-icon-share><span class="hide-title-mobile">{{$t('share')}}</span></b-col>
                  </b-row>
                  <b-row v-else class="forumFooter">
                    <b-col :cols="showFullWhoInDescription ? 4 : 3" @click.stop="toggleSignUpWhoIn(item)" class="py-2"><b-icon-person-check-fill class="opensalud-blue margin-right-icon" v-if="signedUpWhoInActivity(item.whoInData)"></b-icon-person-check-fill><b-icon-person-check class="margin-right-icon" v-else></b-icon-person-check><span class="hide-title-mobile" v-html="`${getSignUpTitle(item.whoInData)} `"></span><span v-html="getWhoInParticipants(item.whoInData)"></span></b-col>
                    <b-col v-if="!showFullWhoInDescription" cols="3" @click.stop="toggleWhoInDescription(item)" class="py-2"><b-icon-info-circle class="margin-right-icon"></b-icon-info-circle><span class="hide-title-mobile">{{ item.showingFullDetails ? $t('hideDetails') : $t('showDetails') }}</span></b-col>
                    <b-col :cols="showFullWhoInDescription ? 4 : 3" v-if="!showAnswerBtn" class="py-2"><b-icon-chat-left class="margin-right-icon"></b-icon-chat-left><span class="hide-title-mobile">{{$t('commentaries')}}</span><span v-if="item.totalMessages"><span class="hide-title-mobile">: </span><span class="opensalud-blue">{{item.totalMessages}}</span></span></b-col> 
                    <b-col :cols="showFullWhoInDescription ? 4 : 3" @click.stop="showEntryAnswerBlock" class="py-2" v-else><b-icon-chat-left class="margin-right-icon"></b-icon-chat-left><span class="hide-title-mobile">{{$t('comment')}}</span></b-col>
                    <b-col :cols="showFullWhoInDescription ? 4 : 3" v-if="canEditForumEntry(item.id) || canModifyForumEntry(item.id)" class="py-2" :id="`more-options-${item.id}`" @click.stop=""><b-icon-three-dots scale="1.5"></b-icon-three-dots></b-col>
                    <b-col v-else :cols="showFullWhoInDescription ? 4 : 3" class="py-2" @click.stop :id="`share-socials-${item.id}`"><b-icon-share class="margin-right-icon"></b-icon-share><span class="hide-title-mobile">{{$t('share')}}</span></b-col>
                  </b-row>
                </div>
            </div>
            <div style="margin-top: 2%;" v-if="showValidateEntry">
                <base-button green @click="validateEntry(item.id, true)">{{$t('validate')}}</base-button>
                <base-button red @click="validateEntry(item.id, false)">{{$t('reject')}}</base-button>
            </div>
            <social-sharing-popover :url="shareArticleLink(item.id)" :targetId="`share-socials-${item.id}`" :sectionName="getForumSectionTitle($store.state.forum.sectionId, true)"></social-sharing-popover>
            <b-popover :target="`more-options-${item.id}`" triggers="click" placement="top">
              <b-row class="more-options-row">
                <b-col cols="12" @click.stop :id="`share-socials-popover-${item.id}`"><div class="more-options-item"><b-icon-share class="margin-right-icon"></b-icon-share><span class="hide-title-mobile">{{$t('share')}}</span></div></b-col>
                <b-col cols="12" @click.stop="updateEntry(item)" v-if="canEditForumEntry(item.id)"><div class="more-options-item"><b-icon-pencil-square class="margin-right-icon"></b-icon-pencil-square><span class="hide-title-mobile">{{$t('edit')}}</span></div></b-col>
                <b-col cols="12" @click.stop="() => { showConfirmDelete = true; entryIdSelected = item.id; $root.$emit('bv::hide::popover') }" v-if="canModifyForumEntry(item.id)"><div class="more-options-item"><b-icon-trash class="margin-right-icon"></b-icon-trash><span class="hide-title-mobile">{{$t('remove')}}</span></div></b-col>
                <social-sharing-popover :url="shareArticleLink(item.id)" :targetId="`share-socials-popover-${item.id}`" :sectionName="getForumSectionTitle($store.state.forum.sectionId, true)"></social-sharing-popover>
              </b-row>
            </b-popover>
        </div>
        <base-dialog :value="showConfirmDelete" :okFn="() => { removeEntry(); showConfirmDelete = false; }" :cancelFn="() => { showConfirmDelete = false; }" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :content="$t('removePostAdvice')"></base-dialog>
        <div @click="loadMoreEntries" class="seeMoreEntries" v-if="showMorePostMessages && !hideFooter">
            <b-icon class="pointer" icon="arrow-down" scale="0.7"></b-icon>
            <span class="pointer">{{$t('showMoreEntries')}}</span>
        </div>
    </div>
    <div style="margin-top: 30vh;" v-else>
        <h1 v-if="$store.state.forum.entrySearchValue">{{$t('emptyEntriesSearch')}}</h1>
        <div v-else-if="inWhoInSection">
          <h1>{{$t('emptyActivitiesSearch')}}</h1>
          <base-button class="mt-3" @click="createNewPost">{{ $t('proposeNewActivity') }}</base-button>
        </div>
        <h1 v-else>{{$t('emptyEntries')}}</h1>
    </div>
</div>
</template>

<script>
import { BModal, BButton, BPopover } from 'bootstrap-vue'
import BaseButton from '@/components/base/buttons/BaseButton'
import SocialSharingPopover from '@/components/base/ui/SocialSharingPopover'
import forumMixin from '@/mixins/forum.mixin'
import BaseDialog from '@/components/base/BaseDialog'
import { longDateFormat } from '@/helpers/date.helpers'
import forumRepository from '@/repositories/ForumRepository'

export default {
  name: 'forum-article-block',
  components: {
    BaseButton,
    SocialSharingPopover,
    BPopover,
    BaseDialog,
    BModal,
    BButton
  },
  mixins: [forumMixin],
  props: {
    resetValue: Boolean,
    disableClick: Boolean,
    showImage: Boolean,
    hideFooter: Boolean,
    showValidateEntry: Boolean,
    showAnswerBtn: Boolean,
    hideForumDescriptionMobile: Boolean,
    showFullWhoInDescription: Boolean
  },
  data () {
    return {
      showConfirmDelete: false,
      entryIdSelected: null
    }
  },
  created () {
  },
  computed: {
    showMorePostMessages () {
      return this.$store.state.forum.numEntries > this.$store.state.forum.articleData.length
    },
    hideForumDescription () {
      return this.hideForumDescriptionMobile && !this.inWhoInSection
    }
  },
  methods: {
    forumBlockClick (e) {
        if (this.disableClick) {
            return
        }
        if (!this.$store.getters['session/isLogged']) {
            this.logIn()
            return
        }
        this.$router.push(this.getPathUrl(e.currentTarget.id))
    },
    loadMoreEntries () {
        this.$emit('loadMoreEntries')
    },
    shareArticleLink (id) {
        if (!this.disableClick) {
            return `${location.href}/${id}`
        } else {
            return location.href
        }
    },
    articleLike (id) {
      if (!this.$store.getters['session/isLogged']) {
        this.logIn()
        return
      }
      let like = !this.$store.state.forum.userBasicInfo.entriesLike.includes(id)
      this.$api.put('/Forum/UpdateEntryLike', null, {params: {entryId: id, like: like}}).then((response) => {
        if (response.data) {
          let item = this.$store.state.forum.articleData.find(item => item.id === id)
          if (like) {
              this.$store.state.forum.userBasicInfo.entriesLike.push(id)
              item.likes = item.likes > 0 ? ++item.likes : 1
          } else {
              this.$store.state.forum.userBasicInfo.entriesLike = this.$store.state.forum.userBasicInfo.entriesLike.filter(item => item !== id)
              --item.likes
          }
          this.updateLastInteractionDate(id)
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    saveArticle (id) {
      if (!this.$store.getters['session/isLogged']) {
        this.logIn()
        return
      }
      let save = !this.$store.state.forum.userBasicInfo.entriesSaved.includes(id)
      this.$api.put('/Forum/UpdateSaveEntry', null, {params: {entryId: id, save: save}}).then((response) => {
        if (response.data) {
          if (save) {
              this.$store.state.forum.userBasicInfo.entriesSaved.push(id)
          } else {
              this.$store.state.forum.userBasicInfo.entriesSaved = this.$store.state.forum.userBasicInfo.entriesSaved.filter(item => item !== id)
          }
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    removeEntry () {
      if (!this.$store.getters['session/isLogged']) {
        this.logIn()
        return
      }
      this.$api.delete('/Forum/RemoveEntry', {params: {entryId: this.entryIdSelected}}).then((response) => {
        if (response.data) {
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
          this.loadForumEntries()
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    validateEntry (id, validate) {
      this.$api.post('/Forum/ValidateEntry', null, {params: {entryId: id, validate: validate}}).then((response) => {
        if (response.data) {
          this.$emit('updateValidatedEntries')
          this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    showEntryAnswerBlock () {
      this.$store.state.forum.showMainAnswerBlock = !this.$store.state.forum.showMainAnswerBlock
    },
    toggleWhoInDescription (data) {
      data.showingFullDetails = !data.showingFullDetails
      data.description = data.showingFullDetails ? this.getWhoInDescription(data.whoInData) : this.getWhoInDescriptionShort(data.whoInData)
    },
    getWhoInDescriptionShort (data) {
      let whoInDescription = ''
      const keysToShow = ['activity', 'activityLevel', 'city', 'startDate', 'endDate']
      Object.keys(data).filter(key => keysToShow.includes(key)).forEach(key => {
        if (data[key]) {
          whoInDescription = whoInDescription.concat('', `<p><b>${this.$t(`whoInDataTitles.${key}`)}</b>: ${this.getWhoInPropValue(data, key)}</p>`)
        }
      })
      return whoInDescription
    },
    getWhoInDescription (data) {
      let whoInDescription = ''
      const keysToExclude = ['participantsLimit', 'noStartTime', 'noEndTime']
      const participantsKey = 'participants'
      Object.keys(data).filter(key => !keysToExclude.includes(key)).forEach(key => {
        if (key === participantsKey) {
          whoInDescription = whoInDescription.concat('', `<p><b>${this.$t(`whoInDataTitles.participants`)}</b>: ${data[key].map(item => item.fullName).join(', ')}</p>`)
        } else if (data[key]) {
          whoInDescription = whoInDescription.concat('', `<p><b>${this.$t(`whoInDataTitles.${key}`)}</b>: ${this.getWhoInPropValue(data, key)}</p>`)
        }
      })
      return whoInDescription
    },
    getWhoInPropValue (data, key) {
      const startDateKey = 'startDate'
      const endDateKey = 'endDate'
      const noStartTimeKey = 'noStartTime'
      const noEndTimeKey = 'noEndTime'
      const value = data[key]

      if (typeof value === 'object') {
        return value[this.normalizeForumProp('name')]
      } else if (!isNaN(new Date(value))) {
        let excludeTime = (key === startDateKey && data[noStartTimeKey]) || (key === endDateKey && data[noEndTimeKey])
        return longDateFormat(value, excludeTime)
      } else {
        return value
      }
    },
    getWhoInParticipants (data) {
      if (data.participantsLimit) {
        return `(${data.participants.length}/${data.participantsLimit})`
      } else {
        return `(${data.participants.length})`
      }
    },
    signedUpWhoInActivity (data) {
      return data.participants.some(p => p.userId === this.$store.state.forum.userBasicInfo.userAspId)
    },
    getSignUpTitle (data) {
      return `${this.signedUpWhoInActivity(data) ? this.$t('noAssistWhoInActivity') : this.$t('signUpWhoIn')}`
    },
    updateEntry (data) {
      if (this.inWhoInSection) {
        this.$store.state.forum.editingEntry = true
        this.createNewPost(this.$store.state.forum.articleData.find(item => item.id === data.id))
      } else {
        this.$store.state.forum.wysiwygEntryAnswer = data.description
        this.$store.state.forum.editingEntry = true
        this.showEntryAnswerBlock()
        this.$root.$emit('bv::hide::popover')
        this.$router.push(this.getPathUrl(data.id))
      }
    },
    toggleSignUpWhoIn (item) {
      const entryId = item.id
      const value = !this.signedUpWhoInActivity(item.whoInData)
      if (value && item.whoInData.participantsLimit && item.whoInData.participants.length >= item.whoInData.participantsLimit) {
        this.$store.dispatch('showInfoAlert', this.$t('participantsLimitsReached'))
        return
      }
      forumRepository.updateWhoInParticipant({ entryId: entryId, value: value }).then(response => {
        if (response) {
          let entry = this.$store.state.forum.articleData.find(item => item.id === entryId)
          if (value) {
            entry.whoInData.participants.push(response.data)
          } else {
            entry.whoInData.participants = entry.whoInData.participants.filter(p => p.userId !== this.$store.state.forum.userBasicInfo.userAspId)
          }
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    }
  }
}
</script>

<style lang="scss">
    @import './static-appopensalud/css/scss/bootstrap-variables.scss';

    .forumBlock {
      width: 50vw;
      vertical-align: baseline;
      margin-bottom: 3rem;
      cursor: pointer;
      @include media(mobile, tablets) {
        width: 97vw;
      }
    }

    .forumArticleTitle {
        margin: 1.5% !important;
        color: $blue;
        @include media(mobile, tablets) {
          font-size: 1.5em;
        }
    }
    
    .forumImageSize {
        width: 350px;
        @include screen-xl-grid {
          width: 600px;
        }
    }
    
    .seeMoreEntries {
      text-align: center;
      margin-bottom: 5%;
    }

    .forumDescription {
      margin: 3% 2% 1.5% 2%;     
    }

    .whoInDescription {
      margin: 1rem !important;
    }

    @include media(mobile, tablets) {
      .hide-forum-description-mobile{
        display: none;
      }
    }

    .forumDescriptionEllipsis {
      p {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      margin: 3% 1% 1% 1% !important;
    }

    .popover-more-options {
      display: flex;
      min-width: 35px;
      @include media(mobile) {
        flex-direction: column;
        width: initial;
      }
    }

    .margin-left-more-options {
      margin-left: 3%;
    }
    .show-more-details {
      color: $blue;
      cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/ForumArticleBlock.vue